var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUndo = function SvgIconUndo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    d: "M12 2.5c5.277 0 9.5 4.254 9.5 9.5a9.5 9.5 0 0 1-19 0v-.5h1v.5a8.5 8.5 0 0 0 17 0c0-4.695-3.777-8.5-8.5-8.5-2.851 0-4.992 1.186-6.43 2.384A11.6 11.6 0 0 0 3.98 7.5H7.5v1h-5V3h1v3.514c.367-.42.843-.909 1.43-1.398C6.492 3.814 8.852 2.5 12 2.5Z"
  })));
};
export default SvgIconUndo;